import React from 'react';
import {
  FaCogs,
  FaPrint,
  FaCut,
  FaBoxOpen,
  FaQuestionCircle,
  FaClock,
} from 'react-icons/fa';

export const statusMap = {
  undefined: { color: 'secondary', label: 'Неопознанный', icon: <FaQuestionCircle className="me-1" /> },
  new: { color: 'secondary', label: 'Новый', icon: <FaClock className="me-1" /> },

  layouting_awaiting: { color: 'warning', label: 'Ожидает компоновки', icon: <FaCogs className="me-1" /> },
  layouting: { color: 'primary', label: 'Компонуется', icon: <FaCogs className="me-1" /> },
  layouting_completed: { color: 'success', label: 'Компоновка завершена', icon: <FaCogs className="me-1" /> },

  printing_awaiting: { color: 'warning', label: 'Ожидает печати', icon: <FaPrint className="me-1" /> },
  printing: { color: 'primary', label: 'Печатается', icon: <FaPrint className="me-1" /> },
  printing_completed: { color: 'success', label: 'Печать завершена', icon: <FaPrint className="me-1" /> },

  cutting_awaiting: { color: 'warning', label: 'Ожидает резки', icon: <FaCut className="me-1" /> },
  cutting: { color: 'primary', label: 'Режется', icon: <FaCut className="me-1" /> },
  cutting_completed: { color: 'success', label: 'Резка завершена', icon: <FaCut className="me-1" /> },

  packaging_awaiting: { color: 'warning', label: 'Ожидает упаковки', icon: <FaBoxOpen className="me-1" /> },
  packaging: { color: 'primary', label: 'Упаковывается', icon: <FaBoxOpen className="me-1" /> },
  packaging_completed: { color: 'success', label: 'Упакован', icon: <FaBoxOpen className="me-1" /> },
};

const StatusBadge = ({ status }) => {
  const info = statusMap[status] || {
    color: 'secondary',
    label: status || 'Неизвестно',
    icon: <FaQuestionCircle className="me-1" />,
  };

  return (
    <span
      className={`badge bg-${info.color} d-inline-flex align-items-center`}
      title={info.label}
    >
      {info.icon}
      {info.label}
    </span>
  );
};

export default StatusBadge;
